import { render } from "./RegionKaraganda.vue?vue&type=template&id=f16a56d2&ts=true"
import script from "./RegionKaraganda.vue?vue&type=script&lang=ts"
export * from "./RegionKaraganda.vue?vue&type=script&lang=ts"

import "./RegionKaraganda.vue?vue&type=style&index=0&id=f16a56d2&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__